export const globalSearchTriggerDataId = 'global-search-trigger'
